module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/08-8589ff86ad54b2f5f37decc6ba70df12.png";